module.exports = __webpack_public_path__ + "static/media/d8Picker_screenshot.63c7b99f.png";